import React from "react";
import { Spin } from "antd";
import { t as i18nT } from "../i18n";


const Loading = () => {
  return (
    <div className="xima-mobile-scroll-main flex flex-col items-center justify-center h-screen text-center bg-gradient-to-r from-blue-800 to-gray-800">
      <div className="mb-4 animate-bounce">
        <Spin size="large" />
      </div>
      <div className="mt-4 text-2xl font-extrabold text-white">{i18nT("common.loading")}</div>
      <div className="mt-2 text-lg text-gray-200">{i18nT("common.pleaseHoldOnAsWeGatherYourData")}</div>
    </div>
  );
};

export default Loading;
